import { render, staticRenderFns } from "./BotForm.vue?vue&type=template&id=2edab568&scoped=true&"
import script from "./BotForm.vue?vue&type=script&lang=js&"
export * from "./BotForm.vue?vue&type=script&lang=js&"
import style0 from "./BotForm.vue?vue&type=style&index=0&id=2edab568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edab568",
  null
  
)

component.options.__file = "BotForm.vue"
export default component.exports